import { useEffect, useState } from "react";
import { API, BACKEND_HOST, getDataFromUrl } from "../../../api";
import { SITE_ID } from "../../../assets/meta/meta";
import { Col, Container, Row, Card, CardHeader, CardBody, Input, Label, Table, Button } from "@/Components/ui";
import CommonDatePicker from "@/Components/Common/CommonDatePicker";
import { dialogService } from "@/utils/dialogService";
;

const formatDateTimeLocalValue = (value) => {
  if (!value)
    return "";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime()))
    return "";
  const timezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - timezoneOffset).toISOString().slice(0, 16);
};

export default function SettingAdvance() {
    const [siteAdminData, setSiteAdminData] = useState(null);
    const [siteAdminError, setSiteAdminError] = useState(null);
    useEffect(() => {
        getDataFromUrl(`${BACKEND_HOST}/sites/site-admins/${SITE_ID}/`)
            .then((data) => {
            setSiteAdminData(data);
        })
            .catch((e) => {
            // console.error(e);
            setSiteAdminError(e);
        });
    }, []);
    const paygateChoices = [
        { value: "hecto", label: "헥토" },
        { value: "nicepay", label: "나이스페이" },
        { value: "toss", label: "토스" },
    ];
    const [paygate, setPaygate] = useState("hecto");
    const [useHecto, setUseHecto] = useState(false);
    const [useNicepay, setUseNicepay] = useState(false);
    const [useToss, setUseToss] = useState(false);
    // TOSS
    const [payClientKey, setPayClientKey] = useState("");
    const [brandpayClientKey, setBrandpayClientKey] = useState("");
    const [tossVariantKey, setTossVariantKey] = useState("");
    const [payKey, setPayKey] = useState("");
    const [brandpayKey, setBrandpayKey] = useState("");
    const [tossGck, setTossGck] = useState("");
    const [tossGsk, setTossGsk] = useState("");
    // NICEPAY
    const [nicepayClientKey, setNicepayClientKey] = useState("");
    const [nicepaySecretKey, setNicepaySecretKey] = useState("");
    // HECTO
    const [hectoClientKey, setHectoClientKey] = useState("");
    const [hectoSecretKey, setHectoSecretKey] = useState("");
    const [hectoMid, setHectoMid] = useState("");
    const [kakaoRestApiKey, setKakaoRestApiKey] = useState("");
    const [kakaoAdminKey, setKakaoAdminKey] = useState("");
    const [kakaoAppId, setKakaoAppId] = useState("");
    const [kakaoJavascriptKey, setKakaoJavascriptKey] = useState("");
    const [kakaoChannelsId, setKakaoChannelsId] = useState("");
    const [isWebPurchase, setIsWebPurchase] = useState(false);
    const [isWebPurchaseTicket, setIsWebPurchaseTicket] = useState(false);
    const [isWebPurchaseLodge, setIsWebPurchaseLodge] = useState(false);
    const [isWebShopping, setIsWebShopping] = useState(false);
    const [isManaged, setIsManaged] = useState(false);
    const [reservOpenDate, setReservOpenDate] = useState("");
    const [reservAvailableDateCount, setReservAvailableDateCount] = useState(0);
    const [orderAvailableStartAt, setOrderAvailableStartAt] = useState("");
    const [kioskCode, setKioskCode] = useState("");
    const [isLoadingKioskCode, setIsLoadingKioskCode] = useState(false);
    const [isGeneratingKioskCode, setIsGeneratingKioskCode] = useState(false);
    const readKioskCode = (data) => {
        if (Object.prototype.hasOwnProperty.call(data, "kiosk_code")) {
            return data.kiosk_code ?? "";
        }
        if (Object.prototype.hasOwnProperty.call(data, "kioskCode")) {
            return data.kioskCode ?? "";
        }
        return undefined;
    };
    const fetchKioskCode = async () => {
        setIsLoadingKioskCode(true);
        try {
            const res = await API.get(`${BACKEND_HOST}/sites/site-admins/${SITE_ID}/kiosk-code/`);
            setKioskCode(res.data?.kiosk_code ?? "");
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setIsLoadingKioskCode(false);
        }
    };
    const fillState = (data) => {
        setUseHecto(!!data.use_hecto);
        setUseNicepay(!!data.use_nicepay);
        setUseToss(!!data.use_toss);
        if (data.use_hecto) {
            setPaygate("hecto");
        }
        else if (data.use_nicepay) {
            setPaygate("nicepay");
        }
        else if (data.use_toss) {
            setPaygate("toss");
        }
        setPayClientKey(data.pay_client_key ?? "");
        setBrandpayClientKey(data.brandpay_client_key ?? "");
        setTossVariantKey(data.toss_variant_key ?? "");
        setPayKey(data.pay_key ?? "");
        setBrandpayKey(data.brandpay_key ?? "");
        setTossGck(data.toss_gck ?? "");
        setTossGsk(data.toss_gsk ?? "");
        setNicepayClientKey(data.nicepay_client_key ?? "");
        setNicepaySecretKey(data.nicepay_secret_key ?? "");
        setHectoClientKey(data.hecto_client_key ?? "");
        setHectoSecretKey(data.hecto_secret_key ?? "");
        setHectoMid(data.hecto_mid ?? "");
        setKakaoRestApiKey(data.kakao_rest_api_key ?? "");
        setKakaoAdminKey(data.kakao_admin_key ?? "");
        setKakaoAppId(data.kakao_app_id ?? "");
        setKakaoJavascriptKey(data.kakao_javascript_key ?? "");
        setKakaoChannelsId(data.kakao_channels_id ?? "");
        setIsWebPurchase(!!data.is_web_purchase);
        setIsWebPurchaseTicket(!!data.is_web_purchase_ticket);
        setIsWebPurchaseLodge(!!data.is_web_purchase_lodge);
        setIsWebShopping(!!data.is_web_shopping);
        setIsManaged(!!data.is_managed);
        setReservOpenDate(data.reserv_open_date ?? "");
        setReservAvailableDateCount(data.reserv_available_date_count ?? 0);
        setOrderAvailableStartAt(formatDateTimeLocalValue(data.order_available_start_at));
        const loadedKioskCode = readKioskCode(data);
        if (loadedKioskCode === undefined) {
            fetchKioskCode();
        }
        else {
            setKioskCode(String(loadedKioskCode));
        }
    };
    useEffect(() => {
        if (siteAdminData) {
            fillState(siteAdminData);
        }
    }, [siteAdminData]);
    const handleUpdate = () => {
        const pgFeild: any = {};
        if (paygate === "hecto") {
            pgFeild.use_hecto = true;
            pgFeild.use_nicepay = false;
            pgFeild.use_toss = false;
        }
        else if (paygate === "nicepay") {
            pgFeild.use_hecto = false;
            pgFeild.use_nicepay = true;
            pgFeild.use_toss = false;
        }
        else if (paygate === "toss") {
            pgFeild.use_hecto = false;
            pgFeild.use_nicepay = false;
            pgFeild.use_toss = true;
        }
        const data = {
            ...pgFeild,
            pay_client_key: payClientKey,
            brandpay_client_key: brandpayClientKey,
            toss_variant_key: tossVariantKey,
            pay_key: payKey,
            brandpay_key: brandpayKey,
            toss_gck: tossGck,
            toss_gsk: tossGsk,
            nicepay_client_key: nicepayClientKey,
            nicepay_secret_key: nicepaySecretKey,
            hecto_client_key: hectoClientKey,
            hecto_secret_key: hectoSecretKey,
            hecto_mid: hectoMid,
            kakao_rest_api_key: kakaoRestApiKey,
            kakao_admin_key: kakaoAdminKey,
            kakao_app_id: kakaoAppId,
            kakao_javascript_key: kakaoJavascriptKey,
            kakao_channels_id: kakaoChannelsId,
            is_web_purchase: isWebPurchase,
            is_web_purchase_ticket: isWebPurchaseTicket,
            is_web_purchase_lodge: isWebPurchaseLodge,
            is_web_shopping: isWebShopping,
            is_managed: isManaged,
            reserv_open_date: reservOpenDate,
            reserv_available_date_count: reservAvailableDateCount,
            order_available_start_at: orderAvailableStartAt || null,
        };
        API.patch(`${BACKEND_HOST}/sites/site-admins/${SITE_ID}/`, data)
            .then(async (res) => {
            if (res.status === 200 || res.data) {
                await dialogService.handleAlert("저장되었습니다.");
            }
            else {
                await dialogService.handleAlert("저장에 실패했습니다.");
            }
        })
            .catch(async (e) => {
            console.error(e);
            await dialogService.handleAlert("저장에 실패했습니다.", { force: "error" });
        });
    };
    const handleGenerateKioskCode = async () => {
        setIsGeneratingKioskCode(true);
        try {
            const res = await API.post(`${BACKEND_HOST}/sites/site-admins/${SITE_ID}/generate-kiosk-code/`, {});
            setKioskCode(String(res.data?.kiosk_code ?? ""));
            await dialogService.handleAlert("키오스크 코드가 생성되었습니다.");
        }
        catch (e) {
            console.error(e);
            await dialogService.handleAlert("키오스크 코드 생성에 실패했습니다.", { force: "error" });
        }
        finally {
            setIsGeneratingKioskCode(false);
        }
    };
    const hasKioskCode = kioskCode.trim().length > 0;
    if (siteAdminError) {
        return <div>에러 발생: {siteAdminError.message}</div>;
    }
    if (!siteAdminData) {
        return <div>로딩중...</div>;
    }
    return (<div>
      <Row>

        <Col md={6}>
          <div className="pt-3 mb-3">
            <h5>지점 예약 설정</h5>
          </div>

          <div className="mb-3">
            <Label htmlFor="reserv-open-date" className="form-label">
              예약 오픈일 <span className="text-danger">* 지정일 이후 일자 예약 가능</span>
            </Label>
            <CommonDatePicker id="reserv-open-date" value={reservOpenDate} clearable onChangeValue={(value) => {
            setReservOpenDate(value);
        }}/>
          </div>
          <div className="mb-3">
            <Label htmlFor="reserv-available-date-count" className="form-label">
              예약 가능일수 <span className="text-danger">* 지정 일수 안으로 예약 가능</span>
            </Label>
            <Input type="number" id="reserv-available-date-count" value={reservAvailableDateCount} onChange={(e) => {
            setReservAvailableDateCount(Number(e.target.value));
        }}/>
          </div>
          <div className="mb-3">
            <Label htmlFor="order-available-start-at" className="form-label">
              예약 결제 가능 시작일시 <span className="text-danger">* 지정 시각 이후부터 예약 결제 가능</span>
            </Label>
            <Input type="datetime-local" id="order-available-start-at" value={orderAvailableStartAt} onChange={(e) => {
            setOrderAvailableStartAt(e.target.value);
        }}/>
            <div className="form-text">비워두면 결제 오픈 시각 제한을 적용하지 않습니다.</div>
            {!!orderAvailableStartAt && <Button color="danger" size="sm" className="mt-2" onClick={() => setOrderAvailableStartAt("")}>
              지우기
            </Button>}
          </div>
          <div className="border-top mt-4 pt-3 mb-3">
            <h5>키오스크 설정</h5>
          </div>
          <div className="mb-3">
            <Label htmlFor="kiosk-code" className="form-label">
              키오스크 코드
            </Label>
            <div className="d-flex gap-2">
              <Input type="text" id="kiosk-code" value={kioskCode} readOnly className="bg-light"/>
              {!hasKioskCode && !isLoadingKioskCode && <Button color="primary" type="button" disabled={isGeneratingKioskCode} onClick={handleGenerateKioskCode}>
                생성
              </Button>}
            </div>
          </div>
        </Col>



        <Col md={6}>
          <div className="border-top mt-3 pt-3 mb-3">
            <h5>결제 서비스(PG) 설정</h5>
          </div>

          <div className="mb-3">
            <Label htmlFor="pg-select" className="form-label">
              PG 선택 <span className="text-danger">*</span>
            </Label>
            <Input type="select" id="pg-select" value={paygate} onChange={(e) => {
            setPaygate(e.target.value);
        }}>
              {paygateChoices.map((pg) => (<option key={pg.value} value={pg.value}>
                  {pg.label}
                </option>))}
            </Input>
          </div>

          {paygate === "toss" && <div className="mb-3">
            <Col>
              <Label htmlFor="pay-client-key" className="form-label">
                Pay Client Key
              </Label>
              <Input type="text" id="pay-client-key" value={payClientKey} onChange={(e) => {
                setPayClientKey(e.target.value);
            }}/>
            </Col>
            <Col>
              <Label htmlFor="brandpay-client-key" className="form-label">
                Brandpay Client Key
              </Label>
              <Input type="text" id="brandpay-client-key" value={brandpayClientKey} onChange={(e) => {
                setBrandpayClientKey(e.target.value);
            }}/>
            </Col>
            <Col>
              <Label htmlFor="toss-variant-key" className="form-label">
                Toss Variant Key
              </Label>
              <Input type="text" id="toss-variant-key" value={tossVariantKey} onChange={(e) => {
                setTossVariantKey(e.target.value);
            }}/>
            </Col>
            <Col>
              <Label htmlFor="pay-key" className="form-label">
                Pay Key
              </Label>
              <Input type="text" id="pay-key" value={payKey} onChange={(e) => {
                setPayKey(e.target.value);
            }}/>
            </Col>
            <Col>
              <Label htmlFor="brandpay-key" className="form-label">
                Brandpay Key
              </Label>
              <Input type="text" id="brandpay-key" value={brandpayKey} onChange={(e) => {
                setBrandpayKey(e.target.value);
            }}/>
            </Col>
            <Col>
              <Label htmlFor="toss-gck" className="form-label">
                Toss GCK
              </Label>
              <Input type="text" id="toss-gck" value={tossGck} onChange={(e) => {
                setTossGck(e.target.value);
            }}/>
            </Col>
            <Col>
              <Label htmlFor="toss-gsk" className="form-label">
                Toss GSK
              </Label>
              <Input type="text" id="toss-gsk" value={tossGsk} onChange={(e) => {
                setTossGsk(e.target.value);
            }}/>
            </Col>
          </div>}

          {paygate === "nicepay" && <div className="mb-3">
            <Col>
              <Label htmlFor="nicepay-client-key" className="form-label">
                Client Key
              </Label>
              <Input type="text" id="nicepay-client-key" value={nicepayClientKey} onChange={(e) => {
                setNicepayClientKey(e.target.value);
            }}/>
            </Col>
            <Col>
              <Label htmlFor="nicepay-secret-key" className="form-label">
                Secret Key
              </Label>
              <Input type="text" id="nicepay-secret-key" value={nicepaySecretKey} onChange={(e) => {
                setNicepaySecretKey(e.target.value);
            }}/>
            </Col>
          </div>}

          {paygate === "hecto" && <div className="mb-3">
            <Col>
              <Label htmlFor="hecto-client-key" className="form-label">
                Client Key
              </Label>
              <Input type="text" id="hecto-client-key" value={hectoClientKey} onChange={(e) => {
                setHectoClientKey(e.target.value);
            }}/>
            </Col>
            <Col>
              <Label htmlFor="hecto-secret-key" className="form-label">
                Secret Key
              </Label>
              <Input type="text" id="hecto-secret-key" value={hectoSecretKey} onChange={(e) => {
                setHectoSecretKey(e.target.value);
            }}/>
            </Col>
            <Col>
              <Label htmlFor="hecto-mid" className="form-label">
                MID
              </Label>
              <Input type="text" id="hecto-mid" value={hectoMid} onChange={(e) => {
                setHectoMid(e.target.value);
            }}/>
            </Col>
          </div>}
        </Col>

        <Col md={6}>
          <div className="border-top mt-3 pt-3 mb-3">
            <h5>카카오 API 설정</h5>
          </div>

          <div className="mb-3">
            <Label htmlFor="kakao-app-id" className="form-label">
              카카오 앱 ID
            </Label>
            <Input type="text" id="kakao-app-id" value={kakaoAppId} onChange={(e) => setKakaoAppId(e.target.value)} placeholder="App ID"/>
          </div>
          <div className="mb-3">
            <Label htmlFor="kakao-rest-api-key" className="form-label">
              카카오 REST API 키
            </Label>
            <Input type="text" id="kakao-rest-api-key" value={kakaoRestApiKey} onChange={(e) => setKakaoRestApiKey(e.target.value)} placeholder="REST API Key"/>
          </div>
          <div className="mb-3">
            <Label htmlFor="kakao-javascript-key" className="form-label">
              카카오 JavaScript 키
            </Label>
            <Input type="text" id="kakao-javascript-key" value={kakaoJavascriptKey} onChange={(e) => setKakaoJavascriptKey(e.target.value)} placeholder="JavaScript Key"/>
          </div>
          <div className="mb-3">
            <Label htmlFor="kakao-admin-key" className="form-label">
              카카오 Admin 키
            </Label>
            <Input type="text" id="kakao-admin-key" value={kakaoAdminKey} onChange={(e) => setKakaoAdminKey(e.target.value)} placeholder="Admin Key"/>
          </div>
          <div className="mb-3">
            <Label htmlFor="kakao-channels-id" className="form-label">
              카카오 채널 ID (카카오톡 자동안내용)
            </Label>
            <Input type="text" id="kakao-channels-id" value={kakaoChannelsId} onChange={(e) => setKakaoChannelsId(e.target.value)} placeholder="예: _xcx..."/>
          </div>
        </Col>

        <Col md={12}>
          <Button color="primary" size="md" className="float-end" style={{ width: "120px" }} onClick={() => {
            // console.log("save");
            handleUpdate();
        }}>저장</Button>
        </Col>

      </Row>
    </div>);
}
